module.exports = __webpack_public_path__ + "img/home-romantic-dining-banner.7466082b.png";